// extracted by mini-css-extract-plugin
export default {"headerContainer":"CustomHeader_headerContainer__nSlX2","arrowBtn":"CustomHeader_arrowBtn__YrwKE"};